import * as ActionTypes from "constants/ActionTypes";

const initialState = {
    serviceError: "",
    serviceCode: 200,
    reqStatus: "",
    isLoading: false,
    orderlist: [],
    orderdetail: {
        shop: [],
        products: []
    },
    pagination: {
        total: 0,
        page: 1,
        limit: 10,
        totalPages: 0
    }
};

export default function orderReducer(state = initialState, action) {
    switch (action.type) {

        /* Common Triggers */
        case ActionTypes.USER_MAIN_GET_ORDERLIST_PRODUCTS_START:
        case ActionTypes.USER_MAIN_GET_ORDER_DETAIL_START: {
            return {
                ...state,
                isLoading: true,
                reqStatus: action.type,
                serviceError: "",
            };
        }

        /* Common Failures */
        case ActionTypes.USER_MAIN_GET_ORDERLIST_PRODUCTS_FAILURE:
        case ActionTypes.USER_MAIN_GET_ORDER_DETAIL_FAILURE: {
            return {
                ...state,
                isLoading: false,
                reqStatus: action.type,
                serviceError: { ...action.payload },
            };
        }

        case ActionTypes.USER_MAIN_GET_ORDERLIST_PRODUCTS_SUCCESS:
            return { ...state,
                isLoading: false,
                reqStatus: action.type,
                serviceError: "",
                orderlist: action.payload.orders,
                pagination: action.payload.pagination
            };

        case ActionTypes.USER_MAIN_GET_ORDER_DETAIL_SUCCESS:
            return { ...state,
                isLoading: false,
                reqStatus: action.type,
                serviceError: "",
                orderdetail: action.payload.order
            };

        case ActionTypes.USER_MAIN_ORDERS_RESET:

            return { ...state,
                isLoading: false,
                orderlist: [],
                orderdetail: {
                    shop: [],
                    products: []
                },
            };

        default:
    }
    return state;
}
